import React from "react";
import { Carousel, Col, Container, Nav, Row, Tab } from "react-bootstrap";
import Counter from "../../components/Counter";

import "../../assets/css/style.css";
import InteriorConstructionWork from "../../components/InteriorConstructionWork";

// Image imports remain the same
import bg3 from "../../assets/images/imgService1.jpg";
import bg4 from "../../assets/images/imgService2.jpg";
import bg5 from "../../assets/images/imgService3.jpg";
import bg8 from "../../assets/images/bgserv.jpeg";
import bg9 from "../../assets/images/background/bg-9.jpg";
import bg10 from "../../assets/images/bgRoise.jpeg";
import logo from "../../assets/images/lo.png";
import { useTranslation } from "react-i18next";
import ProjectsVideos from "../../components/ProjectsVideos";

interface SlideData {
  backgroundImage: string;
  subtitle: string;
  title: string;
}

const Section = () => {
  const { t } = useTranslation();

  const slideData: SlideData[] = [
    {
      backgroundImage: bg8,
      subtitle: t("landing.bedroomInterior"),
      title: t("landing.interiorDecorators"),
    },
    {
      backgroundImage: bg9,
      subtitle: t("landing.bedroomInterior"),
      title: t("landing.interiorDecorators"),
    },
    {
      backgroundImage: bg10,
      subtitle: t("landing.bedroomInterior"),
      title: t("landing.interiorDecorators"),
    },
  ];

  // Add responsive styles
  const styles = {
    mainContainer: {
      fontFamily: '"Cairo", serif',
    },
    heroSubtitle: {
      fontSize: "clamp(1.25rem, 2vw, 1.875rem)", // 20px to 30px
    },
    heroTitle: {
      fontSize: "clamp(2.5rem, 5vw, 4.375rem)", // 40px to 70px
    },
    sectionTitle: {
      fontSize: "clamp(1.875rem, 3vw, 2.5rem)", // 30px to 40px
    },
    paragraph: {
      fontSize: "clamp(1rem, 1.5vw, 1.25rem)", // 16px to 20px
    },
    serviceParagraph: {
      fontSize: "clamp(1.125rem, 2vw, 1.875rem)", // 18px to 30px
    },
    listItem: {
      fontSize: "clamp(1rem, 1.5vw, 1.25rem)", // 16px to 20px
    },
    tabTitle: {
      fontSize: "clamp(1.125rem, 1.5vw, 1.563rem)", // 18px to 25px
    },
    serviceTitle: {
      fontSize: "clamp(1.875rem, 3vw, 2.5rem)", // 30px to 40px
    },
    serviceDescription: {
      fontSize: "clamp(1.125rem, 2vw, 1.563rem)", // 18px to 25px
    },
  };

  return (
    <React.Fragment>
      {/* Home */}
      <section className="interior-home" id="home" style={styles.mainContainer}>
        <Container fluid className="p-0">
          <Row>
            <Carousel indicators={false}>
              {(slideData || [])?.map((slide: SlideData, index: number) => (
                <Carousel.Item
                  key={index}
                  style={{ backgroundImage: `url(${slide.backgroundImage})` }}
                >
                  <div className="home-center">
                    <div className="home-desc-center">
                      <div className="bg-overlay"></div>
                      <Container>
                        <Row className="justify-content-center">
                          <Col lg={8}>
                            <div className="interior-home-content text-center text-white">
                              <p
                                className="interior-home-subtitle text-uppercase text-center"
                                style={styles.heroSubtitle}
                              >
                                {slide.subtitle}
                              </p>
                              <h4
                                className="interior-home-title mt-4"
                                style={styles.heroTitle}
                              >
                                {slide.title}
                              </h4>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </Row>
        </Container>
      </section>

      {/* About */}
      <section className="section about" id="about">
        <Container>
          <Row className="align-items-center gap-5">
            <Col lg={6} sm={12}>
              <div className="interior-about-content">
                <h4 className="text-uppercase" style={styles.sectionTitle}>
                  {t("about.whoWeAre")}
                </h4>
                <p className="mt-4 text-muted" style={styles.paragraph}
               
                >
                  {t("about.description")}
                </p>

                <Row>
                  <Col lg={6}>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.lightingPlacement")}
                      </h5>
                    </div>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.architecturalDetails")}
                      </h5>
                    </div>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.spacePlanning")}
                      </h5>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.projectManagement")}
                      </h5>
                    </div>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.goodsPurchasing")}
                      </h5>
                    </div>
                    <div className="mt-3">
                      <h5
                        className="text-dark d-flex gap-2 align-items-center"
                        style={styles.listItem}
                      >
                        <i className="mdi mdi-check-all pe-2"></i>
                        {t("about.colorConsulting")}
                      </h5>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg={5} sm={12}>
              <div className="interior-about-img">
                <img src={logo} className="w-75" alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <hr />

      {/* Services */}
      <section className="section interior-services" id="services">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2
                  className="heading-title-title text-uppercase"
                  style={styles.sectionTitle}
                >
                  {t("services.ourServices")}
                </h2>
                <p
                  className="heading-title-desc text-muted mt-4"
                  style={styles.serviceParagraph}
                >
                  {t("services.description")}
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mt-5 pt-4">
            <Col lg={12}>
              <Tab.Container id="pills-tab" defaultActiveKey="#interior">
                <Nav className="nav nav-tabs nav-pills mb-3" role="tablist">
                  <Nav.Item>
                    <Nav.Link eventKey="#interior">
                      <h5
                        className="mb-0 text-uppercase letter-spacing_2 mt-3"
                        style={styles.tabTitle}
                      >
                        {t("services.interior")}
                      </h5>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="#decoration">
                      <h5
                        className="mb-0 text-uppercase letter-spacing_2 mt-3"
                        style={styles.tabTitle}
                      >
                        {t("services.decoration")}
                      </h5>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="#exclusively">
                      <h5
                        className="mb-0 text-uppercase letter-spacing_2 mt-3"
                        style={styles.tabTitle}
                      >
                        {t("services.exclusively")}
                      </h5>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="tab-content" id="pills-tabContent">
                  <Tab.Pane eventKey="#interior">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <h3
                            className="text-uppercase"
                            style={styles.serviceTitle}
                          >
                            {t("services.creativeDesign")}
                          </h3>
                          <p
                            className="text-muted mt-4"
                            style={styles.serviceDescription}
                          >
                            {t("services.creativeDesignDescription")}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg3}
                            className="img-fluid w-100"
                            alt=""
                            style={{ maxHeight: "400px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#decoration">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg4}
                            className="img-fluid w-100"
                            alt=""
                            style={{ maxHeight: "400px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <h3
                            className="text-uppercase"
                            style={styles.serviceTitle}
                          >
                            {t("services.architectDesign")}
                          </h3>
                          <p
                            className="text-muted mt-4"
                            style={styles.serviceDescription}
                          >
                            {t("services.architectDesignDescription")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#exclusively">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <h3
                            className="text-uppercase"
                            style={styles.serviceTitle}
                          >
                            {t("services.creativeDecoration")}
                          </h3>
                          <p
                            className="text-muted mt-4"
                            style={styles.serviceDescription}
                          >
                            {t("services.creativeDecorationDescription")}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg5}
                            className="img-fluid w-100"
                            alt=""
                            style={{ maxHeight: "400px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Counter */}
      <Counter />

      {/* Work */}
      <InteriorConstructionWork />
      {/* Work Videos*/}
      <ProjectsVideos />
    </React.Fragment>
  );
};

export default Section;
